module.exports = __webpack_public_path__ + "/login_ui/img/ms-012a60e1d34602894035a0f3123876aa.svg";